import { createReducer, on } from '@ngrx/store';
import * as CompanyActions from './company-profile.action';
import {
  handleClear,
  handleFailure,
  handleRequest,
  handleSuccess,
} from '@shared/ngrx-factory/factory.reducer';

const defaultLoginResponse: CompanyActions.CompanyResponse = {
  success: false,
  message: '',
  data: null,
  statusCode: 0,
};

export const initialState: CompanyActions.CompanyState = {
  profile: { loading: false, message: null, response: null, error: null },
  information: { loading: false, message: null, response: null, error: null },
  taxInformation: { loading: false, message: null, response: null, error: null },
  shareholders: { loading: false, message: null, response: null, error: null },
  directors: { loading: false, message: null, response: null, error: null },
  registrationProgress: { loading: false, message: null, response: null, error: null },
  submit: { loading: false, message: null, response: null, error: null },
  brelaVerification: { loading: false, message: null, response: null, error: null },
  tinVerification: { loading: false, message: null, response: null, error: null },
  feeConfigByType: { loading: false, message: null, response: null, error: null },
  brelaBillConfirmation: { loading: false, message: null, response: null, error: null },
  updateContactDetails: { loading: false, message: null, response: null, error: null },
  updateCompanyAddressDescription: { loading: false, message: null, response: null, error: null },
};

export const companyProfileReducer = createReducer(
  initialState,

  /* ---------- COMPANY PROFILE ---------- */
  on(CompanyActions.CompanyProfileActions.request, (state) => handleRequest(state, 'profile')),
  on(CompanyActions.CompanyProfileActions.success, (state, { response }) =>
    handleSuccess(state, 'profile', response),
  ),
  on(CompanyActions.CompanyProfileActions.failure, (state, { error }) =>
    handleFailure(state, 'profile', error),
  ),
  on(CompanyActions.CompanyProfileActions.clearState, (state) => handleClear(state, 'profile')),

  /* ---------- COMPANY INFORMATIONS ---------- */
  on(CompanyActions.CompanyInformationActions.request, (state) =>
    handleRequest(state, 'information'),
  ),
  on(CompanyActions.CompanyInformationActions.success, (state, { response }) =>
    handleSuccess(state, 'information', response),
  ),
  on(CompanyActions.CompanyInformationActions.failure, (state, { error }) =>
    handleFailure(state, 'information', error),
  ),
  on(CompanyActions.CompanyInformationActions.clearState, (state) =>
    handleClear(state, 'information'),
  ),

  /* ---------- TAX INFORMATIONS ---------- */
  on(CompanyActions.CompanyTaxInformationActions.request, (state) =>
    handleRequest(state, 'taxInformation'),
  ),
  on(CompanyActions.CompanyTaxInformationActions.success, (state, { response }) =>
    handleSuccess(state, 'taxInformation', response),
  ),
  on(CompanyActions.CompanyTaxInformationActions.failure, (state, { error }) =>
    handleFailure(state, 'taxInformation', error),
  ),
  on(CompanyActions.CompanyTaxInformationActions.clearState, (state) =>
    handleClear(state, 'taxInformation'),
  ),

  /* ---------- DIRECTORS - INFORMATIONS ---------- */
  on(CompanyActions.CompanyCurrentDirectorsActions.request, (state) =>
    handleRequest(state, 'directors'),
  ),
  on(CompanyActions.CompanyCurrentDirectorsActions.success, (state, { response }) =>
    handleSuccess(state, 'directors', response),
  ),
  on(CompanyActions.CompanyCurrentDirectorsActions.failure, (state, { error }) =>
    handleFailure(state, 'directors', error),
  ),
  on(CompanyActions.CompanyCurrentDirectorsActions.clearState, (state) =>
    handleClear(state, 'directors'),
  ),


  /* ---------- SHAREHOLDERS - INFORMATIONS ---------- */
  on(CompanyActions.CompanyShareholdersActions.request, (state) =>
    handleRequest(state, 'shareholders'),
  ),
  on(CompanyActions.CompanyShareholdersActions.success, (state, { response }) =>
    handleSuccess(state, 'shareholders', response),
  ),
  on(CompanyActions.CompanyShareholdersActions.failure, (state, { error }) =>
    handleFailure(state, 'shareholders', error),
  ),
  on(CompanyActions.CompanyShareholdersActions.clearState, (state) =>
    handleClear(state, 'shareholders'),
  ),

  /* ---------- REGISTRATION PROGRESS ---------- */
  on(CompanyActions.RegistrationProgressActions.request, (state) =>
    handleRequest(state, 'registrationProgress'),
  ),
  on(CompanyActions.RegistrationProgressActions.success, (state, { response }) =>
    handleSuccess(state, 'registrationProgress', response),
  ),
  on(CompanyActions.RegistrationProgressActions.failure, (state, { error }) =>
    handleFailure(state, 'registrationProgress', error),
  ),
  on(CompanyActions.RegistrationProgressActions.clearState, (state) =>
    handleClear(state, 'registrationProgress'),
  ),

  /* ---------- SUBMIT REGISTRATION ---------- */
  on(CompanyActions.CompanySubmitActions.request, (state) => handleRequest(state, 'submit')),
  on(CompanyActions.CompanySubmitActions.success, (state, { response }) =>
    handleSuccess(state, 'submit', response),
  ),
  on(CompanyActions.CompanySubmitActions.failure, (state, { error }) =>
    handleFailure(state, 'submit', error),
  ),
  on(CompanyActions.CompanySubmitActions.clearState, (state) => handleClear(state, 'submit')),

  /* ---------- BRELA VERIFICATION ---------- */
  on(CompanyActions.BrelaVerificationActions.request, (state) =>
    handleRequest(state, 'brelaVerification'),
  ),
  on(CompanyActions.BrelaVerificationActions.success, (state, { response }) =>
    handleSuccess(state, 'brelaVerification', response),
  ),
  on(CompanyActions.BrelaVerificationActions.failure, (state, { error }) =>
    handleFailure(state, 'brelaVerification', error),
  ),
  on(CompanyActions.BrelaVerificationActions.clearState, (state) =>
    handleClear(state, 'brelaVerification'),
  ),

  /* ---------- TIN VERIFICATION ---------- */
  on(CompanyActions.TinVerificationActions.request, (state) =>
    handleRequest(state, 'tinVerification'),
  ),
  on(CompanyActions.TinVerificationActions.success, (state, { response }) =>
    handleSuccess(state, 'tinVerification', response),
  ),
  on(CompanyActions.TinVerificationActions.failure, (state, { error }) =>
    handleFailure(state, 'tinVerification', error),
  ),
  on(CompanyActions.TinVerificationActions.clearState, (state) =>
    handleClear(state, 'tinVerification'),
  ),

  /* ---------- FEE CONFIGURATION BY TYPE ---------- */
  on(CompanyActions.FeeConfigByTypeActions.request, (state) =>
    handleRequest(state, 'feeConfigByType'),
  ),
  on(CompanyActions.FeeConfigByTypeActions.success, (state, { response }) =>
    handleSuccess(state, 'feeConfigByType', response),
  ),
  on(CompanyActions.FeeConfigByTypeActions.failure, (state, { error }) =>
    handleFailure(state, 'feeConfigByType', error),
  ),
  on(CompanyActions.FeeConfigByTypeActions.clearState, (state) =>
    handleClear(state, 'feeConfigByType'),
  ),


  /* ---------- BRELA BILL CONFIRMATION ---------- */
  on(CompanyActions.BrelaBillConfirmationActions.request, (state) =>
    handleRequest(state, 'brelaBillConfirmation'),
  ),
  on(CompanyActions.BrelaBillConfirmationActions.success, (state, { response }) =>
    handleSuccess(state, 'brelaBillConfirmation', response),
  ),
  on(CompanyActions.BrelaBillConfirmationActions.failure, (state, { error }) =>
    handleFailure(state, 'brelaBillConfirmation', error),
  ),
  on(CompanyActions.BrelaBillConfirmationActions.clearState, (state) =>
    handleClear(state, 'brelaBillConfirmation'),
  ),

  /* ---------- UPDATE CONTACT DETAILS ---------- */
  on(CompanyActions.UpdateContactDetailsActions.request, (state) =>
    handleRequest(state, 'updateContactDetails'),
  ),
  on(CompanyActions.UpdateContactDetailsActions.success, (state, { response }) => {
    const nextState = handleSuccess(state, 'updateContactDetails', response);
    const updatedContactDetails = response?.data?.data?.contactDetails;
    if (updatedContactDetails && state.information?.response?.data?.data) {
      return {
        ...nextState,
        information: {
          ...state.information,
          response: {
            ...state.information.response,
            data: {
              ...state.information.response.data,
              data: {
                ...state.information.response.data.data,
                contactDetails: updatedContactDetails,
              },
            },
          },
        },
      };
    }
    return nextState;
  }),
  on(CompanyActions.UpdateContactDetailsActions.failure, (state, { error }) =>
    handleFailure(state, 'updateContactDetails', error),
  ),
  on(CompanyActions.UpdateContactDetailsActions.clearState, (state) =>
    handleClear(state, 'updateContactDetails'),
  ),

  /* ---------- UPDATE COMPANY ADDRESS DESCRIPTION ---------- */
  on(CompanyActions.UpdateCompanyAddressDescriptionActions.request, (state) =>
    handleRequest(state, 'updateCompanyAddressDescription'),
  ),
  on(CompanyActions.UpdateCompanyAddressDescriptionActions.success, (state, { response }) => {
    const nextState = handleSuccess(state, 'updateCompanyAddressDescription', response);
    const updatedAddress = response?.data?.data?.addressDescription;
    if (updatedAddress !== undefined && state.information?.response?.data?.data) {
      return {
        ...nextState,
        information: {
          ...state.information,
          response: {
            ...state.information.response,
            data: {
              ...state.information.response.data,
              data: {
                ...state.information.response.data.data,
                addressDescription: updatedAddress,
              },
            },
          },
        },
      };
    }
    return nextState;
  }),
  on(CompanyActions.UpdateCompanyAddressDescriptionActions.failure, (state, { error }) =>
    handleFailure(state, 'updateCompanyAddressDescription', error),
  ),
  on(CompanyActions.UpdateCompanyAddressDescriptionActions.clearState, (state) =>
    handleClear(state, 'updateCompanyAddressDescription'),
  ),
);

